import {
  Button,
  ColumnHeader,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Group,
  Icon,
  MoreMenu,
  Slider,
} from "@qw/ui";
import { useBook } from "@/providers/use-book";

const TAB_OPTIONS = {
  new: "New",
  renewals: "Renewals",
  quotes: "Quotes",
  won: "Won",
  lost: "Lost",
} as const;

export const BookHeader = () => {
  const {
    isBookViewExpanded,
    showExpired,
    thisYear,
    years,
    tab,
    setIsBookViewExpanded,
    setShowExpired,
    setYears,
    setTab,
  } = useBook();

  const tabLabel = TAB_OPTIONS[tab as keyof typeof TAB_OPTIONS];
  const bookToggleLabel = isBookViewExpanded ? "Collapse book view" : "Expand book view";

  return (
    <ColumnHeader
      icon={<Icon icon="book_2" className="text-base text-muted-foreground" />}
      className="last-of-type:border-b-0"
    >
      <Group type="flex" direction="row" className="min-w-0 flex-1 items-center gap-1 w-full">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="-ml-2 min-w-0 gap-1 px-2 text-[11px] font-semibold tracking-normal text-muted-foreground"
            >
              <span>{tabLabel}</span>
              <Icon icon="keyboard_arrow_down" className="mt-0.25 text-base" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {Object.entries(TAB_OPTIONS).map(([value, label]) => (
              <DropdownMenuItem key={value} onClick={() => setTab(value)} className="cursor-pointer">
                {label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <MoreMenu icon="filter_list" buttonProps={{ className: "rounded-lg", size: "sm" }}>
          <DropdownMenuLabel>Marketing Plans</DropdownMenuLabel>
          <DropdownMenuCheckboxItem checked={showExpired} onCheckedChange={setShowExpired}>
            Show Expired
          </DropdownMenuCheckboxItem>
          <DropdownMenuSeparator />
          <DropdownMenuLabel>Policy Date Range</DropdownMenuLabel>
          <div className="px-2 py-2">
            <Slider displayLabels value={years} min={2023} max={thisYear + 1} onValueChange={setYears} />
          </div>
        </MoreMenu>
      </Group>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        display="icon"
        className="ml-auto rounded-lg"
        aria-label={bookToggleLabel}
        aria-expanded={isBookViewExpanded}
        title={bookToggleLabel}
        onClick={() => setIsBookViewExpanded((expanded) => !expanded)}
      >
        <Icon icon={isBookViewExpanded ? "keyboard_arrow_down" : "keyboard_arrow_up"} />
      </Button>
    </ColumnHeader>
  );
};
